import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import type { EventRow } from '../api/types';
import { dateTime } from '../lib/format';
import { useApp } from '../stores/app';

const LEVEL_BADGE: Record<string, string> = { error: 'error', warn: 'warn', info: 'idle', debug: 'idle' };

export function Events() {
  const { tokenFilter, setTokenFilter, tokens } = useApp();
  const [items, setItems] = useState<EventRow[]>([]);
  const [total, setTotal] = useState(0);
  const [level, setLevel] = useState('');
  const [q, setQ] = useState('');
  const [expanded, setExpanded] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await api.events({
          tokenId: tokenFilter || undefined,
          level: level || undefined,
          q: q || undefined,
          limit: 200,
        });
        if (!cancelled) {
          setItems(res.items);
          setTotal(res.total);
          setError(null);
        }
      } catch (err) {
        if (!cancelled) setError((err as Error).message);
      }
    };
    void load();
    const timer = setInterval(() => void load(), 5000);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, [tokenFilter, level, q]);

  return (
    <>
      <div className="topbar">
        <h1>Логи</h1>
        <select className="shrink" style={{ width: 200 }} value={tokenFilter} onChange={(e) => setTokenFilter(e.target.value)}>
          <option value="">Все токены</option>
          {tokens.map((t) => (
            <option key={t.id} value={t.id}>
              {t.name}
            </option>
          ))}
        </select>
        <select className="shrink" style={{ width: 130 }} value={level} onChange={(e) => setLevel(e.target.value)}>
          <option value="">Все уровни</option>
          <option value="error">error</option>
          <option value="warn">warn</option>
          <option value="info">info</option>
        </select>
        <input
          className="shrink"
          style={{ width: 220 }}
          placeholder="Поиск по тексту"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      {error && <div className="panel error-text">{error}</div>}

      <div className="panel">
        <p className="muted" style={{ fontSize: 12, marginTop: 0 }}>
          Показано {items.length} из {total}.
        </p>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Время</th>
                <th>Уровень</th>
                <th>Код</th>
                <th>Сообщение</th>
                <th>Токен</th>
                <th>Поток</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (
                <tr>
                  <td colSpan={6} className="muted">Событий нет.</td>
                </tr>
              )}
              {items.map((e) => (
                <tr key={e.id} onClick={() => setExpanded(expanded === e.id ? null : e.id)} style={{ cursor: e.details_json ? 'pointer' : 'default' }}>
                  <td className="muted">{dateTime(e.ts)}</td>
                  <td>
                    <span className={`badge ${LEVEL_BADGE[e.level] ?? 'idle'}`}>{e.level}</span>
                  </td>
                  <td className="mono">{e.code}</td>
                  <td className="wrap">
                    {e.message}
                    {expanded === e.id && e.details_json && (
                      <pre style={{ marginTop: 6 }}>{JSON.stringify(JSON.parse(e.details_json), null, 2)}</pre>
                    )}
                  </td>
                  <td className="mono muted">{e.token_id ?? '—'}</td>
                  <td className="mono">
                    {e.stream_key ? <Link to={`/streams/${e.stream_key}`}>{e.stream_key.slice(0, 8)}</Link> : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
